/**
 * Performance optimizations for Shopify theme
 * Improves mobile scrolling performance by optimizing image loading and animations
 */

(function() {
  // Only run on client-side
  if (typeof window === 'undefined') return;
  
  // Helper function to check if device is likely low-powered
  function isLowPoweredDevice() {
    // Check for low memory conditions
    if (navigator.deviceMemory && navigator.deviceMemory < 4) return true;
    
    // Check for battery saving mode
    if (navigator.connection && 
        (navigator.connection.saveData || navigator.connection.effectiveType === 'slow-2g' || 
         navigator.connection.effectiveType === '2g')) {
      return true;
    }
    
    return false;
  }
  
  // Add 'reduced-motion' class to body if device is low-powered
  function setupReducedMotion() {
    if (isLowPoweredDevice() || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.body.classList.add('reduced-motion');
    }
  }
  
  // Optimize image loading with IntersectionObserver
  function optimizeImageLoading() {
    if (!('IntersectionObserver' in window)) return;
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          const srcset = img.getAttribute('data-srcset');
          
          if (src) img.src = src;
          if (srcset) img.srcset = srcset;
          
          img.onload = () => {
            img.classList.add('loaded');
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
          };
          
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '200px 0px', // Start loading when image is 200px from viewport
      threshold: 0.01
    });
    
    // Apply to all images with data-src attribute
    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
    
    // Apply to background images with data-bg attribute
    document.querySelectorAll('[data-bg]').forEach(el => {
      imageObserver.observe(el);
    });
  }
  
  // Optimize scroll performance
  function optimizeScrolling() {
    let ticking = false;
    
    // Debounce scroll events
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Handle scroll events here if needed
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true }); // Use passive listener for better performance
  }
  
  // Initialize optimizations when DOM is ready
  function init() {
    setupReducedMotion();
    optimizeImageLoading();
    optimizeScrolling();
    
    // Disable hover effects on touch devices
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      document.body.classList.add('touch-device');
    }
  }
  
  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
